import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { s as setColor } from './utils.js';
import { l as launch } from './index2.js';
import { d as defineCustomElement$1 } from './pds-icon2.js';

const pdsLinkCss = ":host{display:inline}:host pds-icon{-webkit-margin-start:var(--pine-dimension-2xs);margin-inline-start:var(--pine-dimension-2xs)}.pds-link{-ms-flex-align:center;align-items:center;color:var(--color, var(--pine-color-text));display:-ms-inline-flexbox;display:inline-flex;font-weight:var(--pine-font-weight-medium)}.pds-link:focus-visible{border-radius:var(--pine-dimension-2xs);outline:var(--pine-outline-focus);outline-offset:var(--pine-border-width-thick);position:relative}.pds-link:hover{color:var(--color, var(--pine-color-text-hover));text-decoration:none}:host([color=secondary]) .pds-link{color:var(--pine-color-text-primary)}:host([color=secondary]) .pds-link:hover{color:var(--pine-color-grey-150)}:host([color=accent]) .pds-link{color:var(--pine-color-accent)}:host([color=accent]) .pds-link:hover{color:var(--pine-color-accent-hover)}:host([color=danger]) .pds-link{color:var(--pine-color-danger)}:host([color=danger]) .pds-link:hover{color:var(--pine-color-danger-hover)}.pds-link--sm{font-size:var(--pine-font-size-body-xs)}.pds-link--sm pds-icon{height:var(--pine-dimension-xs);width:var(--pine-dimension-xs)}.pds-link--md{font-size:var(--pine-font-size-body-sm)}.pds-link--md pds-icon{height:var(--pine-dimension-xs);width:var(--pine-dimension-xs)}.pds-link--lg{font-size:var(--pine-font-size-body-md)}.pds-link--lg pds-icon{height:var(--pine-dimension-sm);width:var(--pine-dimension-sm)}.pds-link--plain{text-decoration:none}.pds-link--plain:hover{color:var(--pine-color-text-hover);text-decoration:underline}";

const PdsLink = /*@__PURE__*/ proxyCustomElement(class PdsLink extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Determines whether the link should open in a new tab.
         * @defaultValue false
         */
        this.external = false;
        /**
         * Sets the link variant styles.
         * @defaultValue inline
         */
        this.variant = 'inline';
        /**
         * The font size of the link's text.
         * @defaultValue lg
         */
        this.fontSize = 'lg';
    }
    classNames() {
        const classNames = ['pds-link'];
        if (this.fontSize) {
            classNames.push('pds-link--' + this.fontSize);
        }
        if (this.variant) {
            classNames.push('pds-link--' + this.variant);
        }
        return classNames.join(' ');
    }
    setLinkStyles() {
        if (!this.color)
            return;
        const linkColors = {
            secondary: 'var(--pine-color-text-primary)',
            accent: 'var(--pine-color-accent)',
            danger: 'var(--pine-color-danger)',
        };
        const linkStyles = setColor(this.color, linkColors);
        return linkStyles;
    }
    render() {
        return (h("a", { key: 'f2b3e7f26b833f7b187fce6f36c392415e2499df', class: this.classNames(), href: this.href, id: this.componentId, part: "link", target: this.external ? '_blank' : undefined, style: this.setLinkStyles() }, h("slot", { key: 'c85c0add786ab8a90f7cb0d12b75d65a51b8e313' }, this.href), this.external &&
            h("pds-icon", { key: '2ce9fa8d29168659546bc95b0633815978142bbb', icon: launch, size: this.fontSize })));
    }
    static get style() { return pdsLinkCss; }
}, [1, "pds-link", {
        "color": [1],
        "componentId": [1, "component-id"],
        "external": [4],
        "variant": [1],
        "fontSize": [1, "font-size"],
        "href": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-link", "pds-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsLink);
            }
            break;
        case "pds-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { PdsLink as P, defineCustomElement as d };
//# sourceMappingURL=pds-link2.js.map

//# sourceMappingURL=pds-link2.js.map